import type { FunctionComponent } from 'react';
import { getSaleType } from '../../utils/orders';
import CollapsibleBar from '../CollapsibleBar';
import Products from '../ProductsList/Products';
import ShipmentHeader from '../ProductsList/ShipmentHeader';
import * as styles from './styles.module.scss';

type MobileProductListProps = {
  shipped: Record<string, unknown>[];
  pending: Record<string, unknown>[];
  dropship: Record<string, unknown>[];
  trackShipment: (trackingNumber: string) => void;
};

const MobileProductList: FunctionComponent<MobileProductListProps> = ({
  shipped,
  pending,
  dropship,
  trackShipment,
}) => (
  <section className={styles.productList} data-testid="mobile-product-list-container">
    {shipped.map((shipment, index) => (
      <CollapsibleBar key={shipment} title={`Shipment ${index + 1}`} openOnLoad headerClickable>
        <div className={styles.shipment}>
          <ShipmentHeader
            title={`Shipment ${index + 1}`}
            subtitle={getSaleType(shipment)}
            shipmentDetails={shipment.shipmentDetails}
            trackShipment={trackShipment}
          />
          <div>
            <Products products={shipment.products} />
          </div>
        </div>
      </CollapsibleBar>
    ))}
    {pending.map((shipment) => (
      <CollapsibleBar key={shipment} title="Pending Shipment" openOnLoad headerClickable>
        <div className={styles.shipment}>
          <ShipmentHeader
            title="Pending Shipment"
            subtitle={getSaleType(shipment)}
            shipmentDetails={shipment.shipmentDetails}
            trackShipment={trackShipment}
          />
          <div>
            <Products products={shipment.products} />
          </div>
        </div>
      </CollapsibleBar>
    ))}
    {dropship.map((shipment) => (
      <CollapsibleBar key={shipment} title="Drop Ship" openOnLoad headerClickable>
        <div className={styles.shipment}>
          <ShipmentHeader
            title="Drop Ship"
            subtitle={getSaleType(shipment)}
            shipmentDetails={shipment.shipmentDetails}
            trackShipment={trackShipment}
          />
          <div>
            <Products products={shipment.products} />
          </div>
        </div>
      </CollapsibleBar>
    ))}
  </section>
);

export default MobileProductList;
